/**
 * TRELI SUBSCRIPTION LINKS
 * ========================
 * Configura aquí los links de checkout de Treli para cada combinación de
 * variante de Shopify + periodicidad de entrega.
 *
 * ESTRUCTURA:
 *   window.TreliLinks = {
 *     "VARIANT_ID": {
 *       label: "Etiqueta legible (solo para referencia, no afecta el runtime)",
 *       "30": "https://...",   // Recibir cada 1 mes
 *       "60": "https://...",   // Recibir cada 2 meses
 *       "90": "https://..."    // Recibir cada 3 meses
 *     }
 *   };
 *
 * ─── CÓMO OBTENER LOS VARIANT IDs ───────────────────────────────────────────
 *
 * Opción A — Consola del navegador (más rápido):
 *   1. Abre la página del producto en el sitio
 *   2. Abre DevTools → Consola
 *   3. Pega y ejecuta:
 *
 *      JSON.parse(
 *        document.querySelector('script[data-product-variants]').textContent
 *      ).map(v => ({ id: v.id, option1: v.option1, option2: v.option2, title: v.title }))
 *
 *   4. El resultado te muestra todos los IDs con sus opciones
 *
 * Opción B — Admin de Shopify:
 *   Productos → [Producto] → click en una variante → la URL contiene el ID:
 *   .../admin/products/PRODUCT_ID/variants/VARIANT_ID
 *
 * ─── PERIODICIDADES ──────────────────────────────────────────────────────────
 *   "30" = Recibir cada 1 mes  (valor del <select name="frequency">)
 *   "60" = Recibir cada 2 meses
 *   "90" = Recibir cada 3 meses
 *
 * ─── COMPORTAMIENTO ──────────────────────────────────────────────────────────
 *   - Si hay un link configurado para la variante + periodicidad activa:
 *       se muestra el botón "SUSCRIBIRME AHORA" → redirige a Treli en nueva pestaña
 *   - Si NO hay link configurado:
 *       el botón de suscripción se oculta completamente
 *
 * ─── EJEMPLO ─────────────────────────────────────────────────────────────────
 *
 * window.TreliLinks = {
 *
 *   // Focus Booster 30 días ─ Limonada de Coco ─ Envase
 *   "12345678901234": {
 *     label: "Limonada de Coco - Envase",
 *     "30": "https://treli.co/checkout/limonada-envase-1mes",
 *     "60": "https://treli.co/checkout/limonada-envase-2meses",
 *     "90": "https://treli.co/checkout/limonada-envase-3meses"
 *   },
 *
 *   // Focus Booster 30 días ─ Limonada de Coco ─ Sachets
 *   "12345678901235": {
 *     label: "Limonada de Coco - Sachets",
 *     "30": "https://treli.co/checkout/limonada-sachets-1mes",
 *     "60": "https://treli.co/checkout/limonada-sachets-2meses",
 *     "90": "https://treli.co/checkout/limonada-sachets-3meses"
 *   },
 *
 *   // Focus Booster 90 días Envase ─ combo Limonada + Cacao + Sandía
 *   "12345678901299": {
 *     label: "Limonada de Coco, Cacao, Sandía - Envase",
 *     "30": "https://treli.co/checkout/combo-lcs-envase-1mes",
 *     "60": "https://treli.co/checkout/combo-lcs-envase-2meses",
 *     "90": "https://treli.co/checkout/combo-lcs-envase-3meses"
 *   }
 *
 * };
 *
 * ─────────────────────────────────────────────────────────────────────────────
 */

window.TreliLinks = {

    //  Focus Booster 30 días ─ Limonada de Coco ─ Envase
    "43471708749847": {
      label: "Limonada de Coco - Envase",
      "30": "https://checkout.treli.co/pl/pl_c5ACgaDqgATOPVYvgrwVIwED",
      "60": "https://checkout.treli.co/pl/pl_fwKZjJ6eXey4XpVX3SfckgIi",
      "90": "https://checkout.treli.co/pl/pl_5TWadK3INirpmQkI9wLCx5yn"
    },
  
    // Focus Booster 30 días ─ Limonada de Coco ─ Sachets
    "43601415143447": {
      label: "Limonada de Coco - Sachets",
      "30": "https://checkout.treli.co/pl/pl_MXlXnuj20pmArxBjGe097yT2",
      "60": "https://checkout.treli.co/pl/pl_ox2H9BKr4GWSGJ8Y2Ojuo8TE",
      "90": "https://checkout.treli.co/pl/pl_cFzu71I8F0MzUTDSuON0OHMw"
    },
  
   //  Focus Booster 30 días ─ Cacao ─ Envase
    "43471708717079": {
      label: "Cacao - Envase",
      "30": "https://checkout.treli.co/pl/pl_7MeyTBoKMQeuHIAPMFFafzo4",
      "60": "https://checkout.treli.co/pl/pl_9Y72RShJoAa5TLFn2avUojH3",
      "90": "https://checkout.treli.co/pl/pl_hBe5jfMPc4aAGLtxGDXvAXg9"
    },

    //  Focus Booster 30 días ─ Cacao ─ Sachets
    "43601415176215": {
      label: "Cacao - Sachets",
      "30": "https://checkout.treli.co/pl/pl_OV8TgwugnOuLUXpwGQTxJjkv",
      "60": "https://checkout.treli.co/pl/pl_DAmUvAXbKvt8tELKAQR5ExzA",
      "90": "https://checkout.treli.co/pl/pl_0TNgNkLIoUZMGFQAmXjFDSbt"
    },

    //  Focus Booster 30 días ─ Sandía-Limón ─ Envase
    "43471708782615": {
      label: "Sandía-Limón - Envase",
      "30": "https://checkout.treli.co/pl/pl_a8KpZ7WsppsnttfUi4Co3zpV",
      "60": "https://checkout.treli.co/pl/pl_iLp1Ybo4TBDgHcaqlMFx3htq",
      "90": "https://checkout.treli.co/pl/pl_sELC0I4okAWCqSy9bG8ma1j7"
    },

    //  Focus Booster 30 días ─ Sandía-Limón ─ Sachets
    "43601415208983": {
      label: "Sandía-Limón - Sachets",
      "30": "https://checkout.treli.co/pl/pl_PVa3rxUbvWN1iC8KgyquCL9I",
      "60": "https://checkout.treli.co/pl/pl_4XT2qMrNBMCrhs0heJz6Tm6V",
      "90": "https://checkout.treli.co/pl/pl_PZ6eEPDT1KAlqE6c6Q2SWGQj"
    },


    //  Focus Booster 30 días ─ Variety Pack ─ Sachets
    "43601415241751": {
      label: "Variety Pack - Sachets",
      "30": "https://checkout.treli.co/pl/pl_0PoGs1T4M7W3Ahz9lMbUFYHU",
      "60": "https://checkout.treli.co/pl/pl_9lKR7haFSAWortYspXknvEJt",
      "90": "https://checkout.treli.co/pl/pl_ump8PFiFQ9bOlNEVUoV939CI"
    },

    //  Focus Booster 90 días ─ Limonada de Coco, Limonada de Coco, Limonada de Coco ─ Envase
    "45035354226711": {
      label: "Limonada de Coco - Envases x3",
      "30": "https://checkout.treli.co/pl/pl_TAknCWvJysgy14ZfdNZZUAxa",
      "60": "https://checkout.treli.co/pl/pl_4Yw8NpSzvwJI421QGcqznS9q",
      "90": "https://checkout.treli.co/pl/pl_jPEJIU6KEZhQpliq3edI50nt"
    },

    //  Focus Booster 90 días ─ Limonada de Coco, Limonada de Coco, Cacao ─ Envase
    "45033917317143": {
      label: "Limonada de Coco, Limonada de Coco, Cacao - Envases x3",
      "30": "https://checkout.treli.co/pl/pl_zqccj3TChfuPziXzWvYxcnye",
      "60": "https://checkout.treli.co/pl/pl_HrHsbst27Vabqop1L3sZpzCv",
      "90": "https://checkout.treli.co/pl/pl_junUeXtZ1kzasCIjtFciN8s6"
    },

    //  Focus Booster 90 días ─ Limonada de Coco, Limonada de Coco, Sandía-Limón ─ Envase
    "45033917415447": {
      label: "Limonada de Coco, Limonada de Coco, Sandía-Limón - Envases x3",
      "30": "https://checkout.treli.co/pl/pl_WKdZTTKCNXjeYQK1DfPe6Gei",
      "60": "https://checkout.treli.co/pl/pl_rGpeS4XyWmpeAi9h8kbel21p",
      "90": "https://checkout.treli.co/pl/pl_m5teXPPysZpn9y1iaNNMlR6P"
    },

    //  Focus Booster 90 días ─ Limonada de Coco, Cacao, Cacao ─ Envase
    "45033917251607": {
      label: "Limonada de Coco, Cacao, Cacao - Envases x3",
      "30": "https://checkout.treli.co/pl/pl_asuGDLvEZxCBTDwh41TNeRFk",
      "60": "https://checkout.treli.co/pl/pl_fI1tCh4CAagYjAaMA7u64dIG",
      "90": "https://checkout.treli.co/pl/pl_QaZUH8ttaOREJKBbMmNCszZ8"
    },

    //  Focus Booster 90 días ─ Limonada de Coco, Cacao, Sandía-Limón ─ Envase
    "45033917349911": {
      label: "Limonada de Coco, Cacao, Sandía-Limón - Envases x3",
      "30": "https://checkout.treli.co/pl/pl_WwGjJppQ5T4WTPkpD98afwZX",
      "60": "https://checkout.treli.co/pl/pl_UtLAHew7sA7NsAMjcchp6fU5",
      "90": "https://checkout.treli.co/pl/pl_rp0N3scM9YJQ17vtaWUtHo9C"
    },

    //  Focus Booster 90 días ─ Limonada de Coco, Sandía-Limón, Sandía-Limón ─ Envase
    "45033917448215": {
      label: "Limonada de Coco, Sandía-Limón, Sandía-Limón - Envases x3",
      "30": "https://checkout.treli.co/pl/pl_IocobJHoQL7nafu2I0IHcqCH",
      "60": "https://checkout.treli.co/pl/pl_3uvpB55Z8T1uaNzsz5kves35",
      "90": "https://checkout.treli.co/pl/pl_RO9QAhwfaj5AP8mRTIdWcLWm"
    },

    //  Focus Booster 90 días ─ Cacao, Cacao, Cacao ─ Envase
    "45035354259479": {
      label: "Cacao, Cacao, Cacao - Envases x3",
      "30": "https://checkout.treli.co/pl/pl_7tItH0ArvYk040OYYegryTYC",
      "60": "https://checkout.treli.co/pl/pl_gbmB81QJ8yhGlMIB3JuZqMNM",
      "90": "https://checkout.treli.co/pl/pl_0lt638tRFarD8U9ann5SLfwe"
    },

    //  Focus Booster 90 días ─ Cacao, Cacao, Sandía-Limón ─ Envase
    "45033917284375": {
      label: "Cacao, Cacao, Sandía-Limón - Envases x3",
      "30": "https://checkout.treli.co/pl/pl_WeUDDKzBTCb2B90OWuqM4QA4",
      "60": "https://checkout.treli.co/pl/pl_vapEBRogLo6dpNT2LAjB7sLS",
      "90": "https://checkout.treli.co/pl/pl_sEx2vkDQ3nFzqw7RE2ydDnb1"
    },

    //  Focus Booster 90 días ─ Cacao, Sandía-Limón, Sandía-Limón ─ Envase
    "45033917382679": {
      label: "Cacao, Sandía-Limón, Sandía-Limón - Envases x3",
      "30": "https://checkout.treli.co/pl/pl_xN7rX6XNkr9qtkz1adOUjY4U",
      "60": "https://checkout.treli.co/pl/pl_rnPWa9BO6uMI8HvD0PA15BcK",
      "90": "https://checkout.treli.co/pl/pl_zl0LVH0GxyxYwXex7jaDo7jk"
    },

    //  Focus Booster 90 días ─ Sandía-Limón, Sandía-Limón, Sandía-Limón ─ Envase
    "45034240049175": {
      label: "Sandía-Limón, Sandía-Limón, Sandía-Limón - Envases x3",
      "30": "https://checkout.treli.co/pl/pl_taGmQh6aAVsC9atGCiga2HMM",
      "60": "https://checkout.treli.co/pl/pl_47bW16eBeJsNE8fATf2qlhX0",
      "90": "https://checkout.treli.co/pl/pl_6qYOMAUqZueUsA5Xvpk2xT1b"
    },

    //  Focus Booster 90 días ─ Limonada de Coco, Limonada de Coco, Limonada de Coco ─ Sachets
    "45052346171415": {
      label: "Limonada de Coco - Sachets x3",
      "30": "https://checkout.treli.co/pl/pl_7vz1DfyBl7578jemmDKOrUob",
      "60": "https://checkout.treli.co/pl/pl_CspdWfSWbqaSff5SmcHAOzG8",
      "90": "https://checkout.treli.co/pl/pl_s1h4IH1gaqiQuUnG17XRbn6l"
    },

    //  Focus Booster 90 días ─ Limonada de Coco, Limonada de Coco, Cacao ─ Sachets
    "45034791075863": {
      label: "Limonada de Coco, Limonada de Coco, Cacao - Sachets x3",
      "30": "https://checkout.treli.co/pl/pl_LeOihwAowIgVo3JGTg1AC0Ar",
      "60": "https://checkout.treli.co/pl/pl_XH4RdQfbRF976Edqfo4wJZ4L",
      "90": "https://checkout.treli.co/pl/pl_d1wIUAkOPJ1NsZOysqJdaL7j"
    },

    //  Focus Booster 90 días ─ Limonada de Coco, Limonada de Coco, Sandía-Limón ─ Sachets
    "45034791108631": {
      label: "Limonada de Coco, Limonada de Coco, Sandía-Limón - Sachets x3",
      "30": "https://checkout.treli.co/pl/pl_T7bRGhtStEZTjEctMNpJl7AH",
      "60": "https://checkout.treli.co/pl/pl_H0IkUlPHrkfXIeeoHAqg9p6u",
      "90": "https://checkout.treli.co/pl/pl_ibf0gV3w3VjG4wYCeYGj1CON"
    },

    //  Focus Booster 90 días ─ Limonada de Coco, Cacao, Cacao ─ Sachets
    "45034791141399": {
      label: "Limonada de Coco, Cacao, Cacao - Sachets x3",
      "30": "https://checkout.treli.co/pl/pl_DBdhKjeXMmyLtPEremKV1d15",
      "60": "https://checkout.treli.co/pl/pl_BxA5gagsDzApBONhDQqdITfx",
      "90": "https://checkout.treli.co/pl/pl_LlSBPBGzLJIHvAvK6Ayg9ryz"
    },

    //  Focus Booster 90 días ─ Limonada de Coco, Cacao, Sandía-Limón ─ Sachets
    "45034791174167": {
      label: "Limonada de Coco, Cacao, Sandía-Limón - Sachets x3",
      "30": "https://checkout.treli.co/pl/pl_a3AEV7fKSbNEdCJEamfPyUe1",
      "60": "https://checkout.treli.co/pl/pl_EG3b2BZWh2gl8VaqXXdONZnp",
      "90": "https://checkout.treli.co/pl/pl_1Bxov6rbjo3U1T468VHBO8hz"
    },

    //  Focus Booster 90 días ─ Limonada de Coco, Sandía-Limón, Sandía-Limón ─ Sachets
    "45034791206935": {
      label: "Limonada de Coco, Sandía-Limón, Sandía-Limón - Sachets x3",
      "30": "https://checkout.treli.co/pl/pl_a2sy390VVUlP9VUkAnKbPYVA",
      "60": "https://checkout.treli.co/pl/pl_3wSw4zthcguFPDIr5gGnH149",
      "90": "https://checkout.treli.co/pl/pl_TkUakuokw48Pc3UTCGRhowzY"
    },

    //  Focus Booster 90 días ─ Cacao, Cacao, Cacao ─ Sachets
    "45052346204183": {
      label: "Cacao, Cacao, Cacao - Sachets x3",
      "30": "https://checkout.treli.co/pl/pl_ov5Una5FnPtWWd1MD8n1lAVp",
      "60": "https://checkout.treli.co/pl/pl_yL3inYFcTvnN3y5lk6mRM5sd",
      "90": "https://checkout.treli.co/pl/pl_HNvALTsA4WvQ0MTJ2kzfrd0f"
    },

    //  Focus Booster 90 días ─ Cacao, Cacao, Sandía-Limón ─ Sachets
    "45034791272471": {
      label: "Cacao, Cacao, Sandía-Limón - Sachets x3",
      "30": "https://checkout.treli.co/pl/pl_BAfQBYKdvwsa0uWIyfdwwL3X",
      "60": "https://checkout.treli.co/pl/pl_a2QfrmwVwhKsEFqvYfL4DjBW",
      "90": "https://checkout.treli.co/pl/pl_LD2bsxiK5SwKnOFYTdT3UNvb"
    },

    //  Focus Booster 90 días ─ Cacao, Sandía-Limón, Sandía-Limón ─ Sachets
    "45034791305239": {
      label: "Cacao, Sandía-Limón, Sandía-Limón - Sachets x3",
      "30": "https://checkout.treli.co/pl/pl_ny9h7grPLAYoaVrSL8hQzJcA",
      "60": "https://checkout.treli.co/pl/pl_dNnNAlUasU5DQcXggQKRQ0zy",
      "90": "https://checkout.treli.co/pl/pl_FMp54pfU6AuaDK2Es2sza5dy"
    },

    //  Focus Booster 90 días ─ Sandía-Limón, Sandía-Limón, Sandía-Limón ─ Sachets
    "45034791338007": {
      label: "Sandía-Limón - Sachets x3",
      "30": "https://checkout.treli.co/pl/pl_wfcdQhJPx9WnEh90Os8GbRcQ",
      "60": "https://checkout.treli.co/pl/pl_aiGhIx1EWNNA18FevhBUoVqs",
      "90": "https://checkout.treli.co/pl/pl_VamN0TSiucAyd7qJvJKf5ghA"
    },

    // ─────────────────────────────────────────────────────────────────
    //  MNRL — Sales Minerales
    // ─────────────────────────────────────────────────────────────────

    //  MNRL 30 Porciones
    "44181698871319": {
      label: "MNRL 30 Porciones",
      // 2026-10-30: el link mensual anterior (pl_Agh305…) traía además Focus Sandía Caja 30 ($173.315)
      "30": "https://checkout.treli.co/pl/pl_yb91PaWjNpz15Ki7P3rMHdqG",
      "60": "https://checkout.treli.co/pl/pl_5wXFYFjMDbawTjtJK12GafAC",
      "90": "https://checkout.treli.co/pl/pl_nQPzbTeLk25jrwCA3iquX7bR"
    },

    //  MNRL 90 Porciones
    "45247096029207": {
      label: "MNRL 90 Porciones",
      "30": "https://checkout.treli.co/pl/pl_T2PPvdIr031PSxTQyWUSOayY",
      "60": "https://checkout.treli.co/pl/pl_eCRlodVi0pUBIP7xG2aHDvDk",
      "90": "https://checkout.treli.co/pl/pl_s3IALs1fX7Egfdyglqh20YDT"
    },

      // ─── BALANCE PACK · ENVASE (solo Sin Shaker · $254.065 con 15% OFF) ────────
  "44217792921623": {
    label: "Balance Pack Envase - Limonada de Coco",
    "30": "https://checkout.treli.co/pl/pl_CWn3oRWOrfZY85VrexOpWkIM",
    "60": "https://checkout.treli.co/pl/pl_ChYCuEpnfZcHoFbR3Nbalevz",
    "90": "https://checkout.treli.co/pl/pl_vNBOJqpJM7aJ81Usg0J2iAmJ"
  },
  "44217792954391": {
    label: "Balance Pack Envase - Cacao",
    "30": "https://checkout.treli.co/pl/pl_wf0oE9RXB6nEMlYhZsPwnacq",
    "60": "https://checkout.treli.co/pl/pl_9v9AvUGXwOavZYxUAKdsM0kU",
    "90": "https://checkout.treli.co/pl/pl_WI17jo38NTOKeD5TOUv9wyBn"
  },
  "44217792987159": {
    label: "Balance Pack Envase - Sandía-Limón",
    "30": "https://checkout.treli.co/pl/pl_QBGqN0BoVwEWZeOEza8T59GO",
    "60": "https://checkout.treli.co/pl/pl_aHIShCFepJHZHxQ069hxtTpB",
    "90": "https://checkout.treli.co/pl/pl_xpdCiYT9jEv6H2CyLxP2jcw7"
  },

  // ─── BALANCE PACK · SACHETS (solo Sin Shaker · $262.565 con 15% OFF) ──────
  "45447120617495": {
    label: "Balance Pack Sachets - Limonada de Coco",
    "30": "https://checkout.treli.co/pl/pl_fkaBlKlMV40elZ2eC80veykD",
    "60": "https://checkout.treli.co/pl/pl_DQ7DrFzlpvPjJwbnKTNQgg64",
    "90": "https://checkout.treli.co/pl/pl_QtA0Fa2YTzWYVAzvHghymAgi"
  },
  "45447120650263": {
    label: "Balance Pack Sachets - Cacao",
    "30": "https://checkout.treli.co/pl/pl_LwMxwEQAMgkFk9lOo9bTmhKl",
    "60": "https://checkout.treli.co/pl/pl_TbAb5DLdkhpqkuGUR29XvZ0B",
    "90": "https://checkout.treli.co/pl/pl_62nySgvn9MrhvstRx52rgBth"
  },
  "45447120683031": {
    label: "Balance Pack Sachets - Sandía-Limón",
    "30": "https://checkout.treli.co/pl/pl_YCrXRfUEghaR4hssPZ5kvSos",
    "60": "https://checkout.treli.co/pl/pl_aNUcLlVQf6mT6KKp8e9XLrlD",
    "90": "https://checkout.treli.co/pl/pl_sC2nSIBA7bmIzmdbhhVWhVlE"
  },
  "45477593120791": {
    label: "Balance Pack Sachets - Variety Pack",
    "30": "https://checkout.treli.co/pl/pl_GgKodgCoYnbbAZFfQKD27oGC",
    "60": "https://checkout.treli.co/pl/pl_Bwd2RQVHBfS2NHGJL90jzb0u",
    "90": "https://checkout.treli.co/pl/pl_EKpkRVgXZayib9lJFaStHNYv"
  },
}